import { Link } from 'react-router';

export function Header({ url, name, height = 150 }) {
    const style = { height: `${height}px` };
    if (url) {
        return (
            <div
                className='company-header'
                style={{ ...style, backgroundImage: `url(${url})` }}></div>
        );
    }

    const color = colors[hash(name) % colors.length];
    return (
        <div
            className={'company-header ' + color}
            style={style}></div>
    );
}

export function Logo({ url, name, size = 32, permalink = '' }) {
    const style = { width: `${size}px`, height: `${size}px` };
    const wrapper = (children) => {
        if (permalink) {
            return <Link to={`/company/${permalink}`}>{children}</Link>;
        }
        return children;
    };
    if (url) {
        return wrapper(
            <div
                className='company-logo'
                style={{ ...style, backgroundImage: `url(${url})` }}></div>,
        );
    }

    const color = colors[hash(name) % colors.length];
    return wrapper(
        <div
            className={'company-logo ' + color}
            style={style}>
            {name && name[0].toUpperCase()}
        </div>,
    );
}

const REMOTELY_HUBSPOT_ID = 22676778;
const CONTACT_ENTITY_ID = '0-1';
const CUSTOMER_ENTITY_ID = '0-2';

function LinkHubSpot({ id, entityId }) {
    return (
        id && (
            <a
                className='light-link'
                href={`https://app.hubspot.com/contacts/${REMOTELY_HUBSPOT_ID}/record/${entityId}/${id}`}
                target='_blank'
                rel='noreferrer'>
                {id}
            </a>
        )
    );
}

export function LinkHubSpotContact({ id }) {
    return LinkHubSpot({ id, entityId: CONTACT_ENTITY_ID });
}

export function LinkHubSpotCustomer({ id }) {
    return LinkHubSpot({ id, entityId: CUSTOMER_ENTITY_ID });
}

const colors = ['purple', 'black', 'yellow', 'tangerine', 'mauve'];

export function hash(str, seed = 3) {
    if (!str) return 0;
    let h1 = 0xdeadbeef ^ seed,
        h2 = 0x41c6ce57 ^ seed;
    for (let i = 0, ch; i < str.length; i++) {
        ch = str.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909);
    h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909);
    return 4294967296 * (2097151 & h2) + (h1 >>> 0);
}
